// config
import { defaultSettings, cookiesKey } from '../config';

// ----------------------------------------------------------------------

export const getSettings = (cookies) => {
  const themeMode = getData(cookies[cookiesKey.themeMode]) || defaultSettings.themeMode;

  const themeDirection = getData(cookies[cookiesKey.themeDirection]) || defaultSettings.themeDirection;

  /* COR E LARGURA NAO SAO MAIS LIDAS DO COOKIE (10/09/2026).

     O painel que as ajustava saiu, entao o cookie virou uma escolha sem como
     desfazer: quem tivesse marcado roxo ou largura limitada em algum momento
     abriria o sistema assim para sempre. Fixar aqui, e nao apagar o cookie,
     porque o valor gravado nao atrapalha - ele simplesmente deixa de ser lido,
     e se um dia o painel voltar a preferencia antiga ainda esta la.

     `themeMode` continua vindo do cookie: e o unico ajuste que sobrou na tela,
     e ele precisa lembrar da escolha entre uma sessao e outra. */
  const themeColorPresets = defaultSettings.themeColorPresets;

  const themeLayout = getData(cookies[cookiesKey.themeLayout]) || defaultSettings.themeLayout;

  // DEFEITO CORRIGIDO (18/08/2026): era
  //
  //   getData(...) || defaultSettings.themeStretch
  //
  // e `defaultSettings.themeStretch` e `true`. `themeStretch` e o UNICO ajuste
  // booleano daqui, e `false || true` da `true`: o `||` engolia justamente o valor
  // que o usuario escolheu. Ele marcava "largura limitada", o cookie era gravado
  // como "false" corretamente, e no proximo carregamento a leitura devolvia
  // "largura total" de novo. Na tela parecia que o botao nao funcionava.
  //
  // Com booleano, `||` nunca serve para default - so `??` (ou um teste de tipo,
  // como aqui, porque cookie ausente chega como string vazia e nao como
  // undefined).
  const themeStretch = true;

  return {
    themeMode,
    themeDirection,
    themeColorPresets,
    themeLayout,
    themeStretch,
  };
};

// ----------------------------------------------------------------------

const getData = (value) => {
  if (value === 'true' || value === 'false') {
    return JSON.parse(value);
  }
  if (value === 'undefined' || !value) {
    return '';
  }
  return value;
};
